import React, { useEffect } from "react";
import { RiBubbleChartLine } from "react-icons/ri";
import { FaTelegramPlane } from "react-icons/fa";
import {IoShapesOutline} from "react-icons/io5";
import "./style.css";
import AOS from "aos";
import "aos/dist/aos.css";

const card = [
  {
    id: 1,
    icon: <IoShapesOutline className="services__card__head__icon mb-3" />,
    heading: "User interface development ",
    para: "“I'm dedicated to creating intuitive, aesthetically pleasing, and functional interfaces that improve the user experience.”",
  },
  {
    id: 2,
    icon: <FaTelegramPlane className=" services__card__head__icon mb-3" />,
    heading: "Website optimization",
    para: "“I use a combination of best practices and cutting-edge technologies to optimize websites for speed, search engines, and user engagement.”",
  },
  {
    id: 3,
    icon: <RiBubbleChartLine className=" services__card__head__icon mb-3" />,
    heading: "ongoing maintenance and support",
    para: "“My maintenance and support services provide ongoing care for your website to keep it secure, up-to-date, and performing at its best.”",
  },
];

function Services() {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <div className="services py-5" id="services">
      <div className="container-lg">
        <div className="services__content my-4 fs-5 pb-4">
          <span
            className="services__content__title-small text-uppercase"
            data-aos={"fade-out"}
            data-aos-offset={10}
            data-aos-duration={800}
          >
            _Services
          </span>
          <h1
            className="services__content__heading my-3"
            data-aos={"fade-out"}
            data-aos-offset={10}
            data-aos-duration={800}
          >
            I provide wide range of development services
          </h1>
          <p className="services__content__detail">
            I work closely with my clients to understand their specific needs
            and goals, ensuring that every project is tailored to their unique
            requirements. Whether you're looking to create a new website, revamp
            your existing site, or develop a custom web application, our
            front-end web development services are the perfect solution.
          </p>
        </div>
        <div className="row">
          {card.map((item) => (
            <div className="col-md-4 col-12" key={item.id}>
              <div
                className="card border-0 services__card py-4 px-4 my-md-0 my-4"
                data-aos={"fade-up"}
                data-aos-offset={10}
                data-aos-duration={800}
              >
                <div className="services__card__head w-100 d-flex justify-content-center flex-column">
                  {item.icon}
                  <h1 className="services__card__head__title text-capitalize fs-3">
                    {item.heading}
                  </h1>
                </div>
                <div className="services__card__body">
                  <p className="services__card__body__content fs-5">
                    {item.para}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Services;
